import { render, staticRenderFns } from "./ExerciseForm.vue?vue&type=template&id=5c2e70c4&scoped=true"
import script from "./ExerciseForm.vue?vue&type=script&lang=js"
export * from "./ExerciseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2e70c4",
  null
  
)

export default component.exports